import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionDataEntry } from '../../../pages/Substitutions/Plan/PlanSubstitutions/utils';
import { DifferentTimeForm } from '../forms/DifferentTimeForm';

type DifferentTimeModalProps = {
  isOpen: boolean;
  originTeachers: SubstitutionDataEntry[];
  originRooms: SubstitutionDataEntry[];
  onClose: () => void;
};

export const DifferentTimeModal = ({ isOpen, originTeachers, originRooms, onClose }: DifferentTimeModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} title={t('substitutions.differentTime')} isOpen={isOpen} onRequestClose={onClose}>
      <DifferentTimeForm
        originTeachers={originTeachers}
        originRooms={originRooms}
        onLoad={setLoading}
        onClose={onClose}
      />
    </Modal>
  );
};
